import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=8e722258&scoped=true&"
import script from "./AddressForm.vue?vue&type=script&lang=js&"
export * from "./AddressForm.vue?vue&type=script&lang=js&"
import style0 from "./AddressForm.vue?vue&type=style&index=0&id=8e722258&prod&scoped=true&lang=scss&"
import style1 from "./AddressForm.vue?vue&type=style&index=1&id=8e722258&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e722258",
  null
  
)

export default component.exports